'use client'
import {
  OrderBoxAssetSelect,
  mapProjectToFlatAsset,
} from '@repo/shared/components'
import { useProject } from '@repo/shared/hooks'
import { useRouter } from '@repo/shared/i18n/navigation'
import { Icon, Row, Separator } from '@repo/ui/components'
import { useSearchParams } from 'next/navigation'
import { useMemo, useState } from 'react'
import type { FlatAsset } from '@repo/shared/components'
import { useListProjects, useUserPortfolio } from '@repo/services'

export const AdvancedTradeCTA = () => {
  const searchParams = useSearchParams()
  const { push, back, replace } = useRouter()
  const [searchQuery, setSearchQuery] = useState('')

  // List projects hook for asset select
  const listProjectsData = useListProjects({
    skip: 0,
    limit: 10,
    // provinceID: 123,
    tradeStatus: 'active',
    kind: 'property',
    ...(searchQuery && {
      q: searchQuery,
    }),
  })

  const tokenFromUrl = useMemo(() => {
    return searchParams.get('token') || undefined
  }, [searchParams])

  const { project } = useProject(tokenFromUrl)

  // Get user portfolio data
  const { data: { data = {} } = {} } = useUserPortfolio()

  const selectedAsset = useMemo(() => {
    if (project) {
      return project as unknown as FlatAsset
    }
    if (tokenFromUrl) {
      return { token: tokenFromUrl } as FlatAsset
    }
    return undefined
  }, [project, tokenFromUrl])

  const setSelectedAsset = (asset: FlatAsset | undefined) => {
    const params = new URLSearchParams(searchParams.toString())

    if (asset?.token) {
      params.set('token', asset.token)
    } else {
      params.delete('token')
    }

    replace(`/advanced-trade?${params.toString()}`)
  }

  // Create allProjects from user portfolio data
  const allProjects = useMemo(() => {
    const projects = data?.projects || []
    return projects
      .filter((project) => project.kind === 'property')
      .map((project) => mapProjectToFlatAsset(project))
  }, [data?.projects])

  return (
    <>
      <Row className='py-xs px-md gap-xs'>
        <Icon
          name='ArrowRight'
          size='md'
          onClick={() => {
            back()
          }}
        />
        <OrderBoxAssetSelect
          containerClassName='bg-neutral-surface-5 max-h-5xl'
          tokenClassName='md:max-w-[165px]'
          iconClassName='min-w-6 max-w-6 min-h-6 max-h-6'
          selectedAsset={selectedAsset}
          onChange={(e) => {
            setSelectedAsset(e)
          }}
          projects={allProjects}
          tab='buy'
          onSearchChange={setSearchQuery}
          listProjectsData={listProjectsData as any}
        />
        <Icon
          name='InfoCircleGhost1'
          size='md'
          onClick={() => {
            push(`/rwa/${selectedAsset?.token}`)
          }}
        />
      </Row>
      <Separator />
    </>
  )
}
